import {alt} from 'epic-react-common';
import generateWithAsyncActions from 'epic-alt-utils';

/**
 * InviteActions
 */
export default generateWithAsyncActions(
  alt,
  ['getCurrentInvites', 'sendInvite'],
  ['reset', 'getPrevPath', 'handleFinish', 'handleError']
);
